/*
 * Copyright (c) 2023 Trimble Inc. All rights reserved.
 */

import Grid from '@mui/material/Grid';
import { Button, CircularProgress } from '@mui/material';
import { withStyles } from '@mui/styles';
import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getFamilies, navigationButtonStyle } from '../common/common';
import { actionCreators } from '../store/UploadConstants';
import './styles.css';
interface Props {
    next: any
    UpdateSelectedFamilies: Function
    selectedFamilies?: any
    UpdateSelectedProductNames: Function
    selectedProductNames?: any
    UpdateSelectedProductModels: Function
    selectedProductModels?: any
    selectedPdf?: any
    classes?: any,
    isDetailLoadingOnConstantName: boolean
    UpdateUploadFamilies: Function
    uploadDetails: any
    FilterUploadNames: Function
    FilterUploadModels: Function
    handleSubmit: any
    selectedNameColors: any,
    selectedModelColors: any,
}
const styles = () => ({
    input: {
        height: 35,
        width: 210
    },
    navigationButton: navigationButtonStyle
})
class ConstantsFileMapping extends React.Component<Props, {}>{
    state =
        {
            ispart: false,
        };
    async componentDidMount() {
        const family = await getFamilies();
        this.props.UpdateUploadFamilies(family.data);
    }
    SelectFamily = async (selectedFamilies: any) => {
        if (this.props.uploadDetails.families !== undefined && selectedFamilies !== undefined) {
            this.props.UpdateSelectedFamilies(selectedFamilies);
            await this.props.FilterUploadNames(this.props.uploadDetails.families, selectedFamilies);
        }
    };
    SelectProductName = async (selectedProductNames: any) => {
        if (this.props.uploadDetails.productNames !== undefined && selectedProductNames !== undefined) {
            this.props.UpdateSelectedProductNames(selectedProductNames);
            await this.props.FilterUploadModels(this.props.uploadDetails.productNames, selectedProductNames);
        }
    };
    selectProductModel = (selectedProductModels: any) => {
        this.props.UpdateSelectedProductModels(selectedProductModels);
    };
    handle = () => {
        this.setState({
            ispart: !this.state.ispart
        });
        console.log(this.state.ispart);
    };
    render() {
        const { classes } = this.props;
        let isDisabled = true, isNextDisabled = true, title = '', isFormControlLabelDisabled = true;
        if (this.props.selectedPdf === undefined) {
            isDisabled = true;
            isFormControlLabelDisabled = true;
            title = '1. Upload the Constants';
        }
        else {
            if (this.props.selectedPdf !== undefined) {
                isNextDisabled = false;
            }
        }

        return (
            <Grid className="classificationGrid" style={this.props.isDetailLoadingOnConstantName ? { width: '45%' } : {}}>
                {this.props.uploadDetails.families &&
                    (
                        this.props.isDetailLoadingOnConstantName ?
                            <div className="uploadClassificationInitial">
                                <CircularProgress color="secondary" />
                            </div>
                            :
                            <Grid style={{ height: '90%' }}>
                                <Grid style={{ height: '5%', textAlign: 'center', fontWeight: 'bold' }}>{title}</Grid>
                            </Grid>
                    )
                }
                <Grid container justifyContent="flex-end" style={{ marginBottom: 20 }}>
                    <Button className={classes.navigationButton} onClick={this.props.handleSubmit} disabled={isNextDisabled}>Upload</Button>
                </Grid>
            </Grid>
        );
    }
}
const mapStateToProps = (state: any) => ({
    selectedFamilies: state.uploadConstants.selectedFamilies,
    selectedProductNames: state.uploadConstants.selectedProductNames,
    selectedProductModels: state.uploadConstants.selectedProductModels,
    selectedPdf: state.uploadConstants.selectedPdf,
    isDetailLoadingOnConstantName: state.uploadConstants.isDetailLoadingOnConstantName,
    uploadDetails: state.uploadConstants.uploadDetails,
    selectedNameColors: state.uploadConstants.selectedNameColors,
    selectedModelColors: state.uploadConstants.selectedModelColors
});

const mapDispatchtoProps = (dispatch: any) =>
    bindActionCreators(actionCreators, dispatch);

const StyledConstantsFileMapping: any = withStyles(styles)(ConstantsFileMapping);
export default connect(
    mapStateToProps,
    mapDispatchtoProps
)(StyledConstantsFileMapping as any);
